import api from './api';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const isPushSupported = () => {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
};

export const getPermission = () => {
  return Notification.permission;
};

export const requestPermission = async () => {
  if (!isPushSupported()) return 'unsupported';
  const permission = await Notification.requestPermission();
  return permission;
};

export const subscribePush = async () => {
  if (!isPushSupported()) return null;
  try {
    const permission = await requestPermission();
    if (permission !== 'granted') return null;

    // Fetch VAPID public key dynamically from backend
    const keyRes = await api.get('/push/vapid-key');
    const vapidKey = keyRes.data?.publicKey;
    if (!vapidKey) {
      console.error('No VAPID key returned from backend');
      return null;
    }

    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
    }

    const subJson = subscription.toJSON();
    await api.post('/push/subscribe', { subscription: subJson });
    return subJson;
  } catch (err) {
    console.error('Push subscription failed:', err);
    return null;
  }
};

export const unsubscribePush = async () => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      const subJson = subscription.toJSON();
      await subscription.unsubscribe();
      await api.post('/push/unsubscribe', { subscription: subJson });
    }
  } catch (err) {
    console.error('Push unsubscribe failed:', err);
  }
};
